module.exports = __webpack_public_path__ + "img/glotto.b840329.webp";